var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-icon"},[_c('buttonc',{style:({background: _vm.color}),attrs:{"type":"icon-overlay"},on:{"click":_vm.OpenPicker}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }